export default "__VITE_ASSET__Ts7mkp0K__"